import { useState } from "react";
import { useQuery } from "react-query";
import useDebounce from "./useDebounceSearch";
import { getPhaseSubmissions } from "services/phase.service";

export default function usePhaseSubmissions(phaseId, defaultQuery) {
  const [query, setQuery] = useState(
    defaultQuery || {
      page: 1,
      limit: 20,
      search: "",
      status: "",
    }
  );
  const debounceSearch = useDebounce(query.search, 1000);

  const { page, status } = query;
  const { isLoading, data, refetch } = useQuery(
    ["phaseSubmissions", status, phaseId, page, debounceSearch],
    async () => await getPhaseSubmissions(phaseId, query)
  );

  const onQueryChange = (name, value) => {
    setQuery((q) => ({ ...q, [name]: value }));
  };

  const onFilter = (queryFilter) => {
    setQuery(queryFilter);
  };

  return { isLoading, data, onQueryChange, onFilter, refetch };
}
